"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "oggiono": {
    "18d52a8e": [{
      "hkey": "b9cf090e",
      "slug": "oggiono",
      "name": "Oggiono",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "b9cf090e",
      "slug": "oggiono",
      "name": "Oggiono",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82831caf": [{
      "hkey": "42d622ef",
      "slug": "imberido-molinatto",
      "name": "Imberido-Molinatto",
      "primary": true,
      "skipSearch": false
    }],
    "imberido": [{
      "hkey": "42d622ef",
      "slug": "imberido-molinatto",
      "name": "Imberido-Molinatto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b31303da": [{
      "hkey": "42d622ef",
      "slug": "imberido-molinatto",
      "name": "Imberido-Molinatto",
      "primary": true,
      "skipSearch": false
    }],
    "molinatto": [{
      "hkey": "42d622ef",
      "slug": "imberido-molinatto",
      "name": "Imberido-Molinatto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "oggiono"
    }]
  }
};
exports["default"] = _default;